import type { PoStage, ReqStage } from "@po/shared";
import type { ReqSummary } from "../lib/api";
import { int, stageLabel, stageVar } from "../lib/format";
import { useDashboard } from "../pages/Dashboard";
import { useTabQuery } from "../tabs/common";
import { StageCards } from "./charts";

const PIPE: ReqStage[] = ["awaiting_superintendent", "sourcing", "ready_to_order", "po_in_approval", "ordered", "partly_received", "received"];

/** Stages whose card opens the RFQ or PO tab, with the PO stage to filter by; the rest filter requisitions. */
const GOES_TO: Record<string, { tab: "rfqs" | "pos"; poStage?: PoStage[] }> = {
  sourcing: { tab: "rfqs" },
  ready_to_order: { tab: "pos" },
  po_in_approval: { tab: "pos", poStage: ["price_approval"] },
  ordered: { tab: "pos", poStage: ["ordered"] },
};

/** The requisition pipeline, one card per stage, shown on the Requisitions, RFQ and PO tabs. */
export function PipelineCards() {
  const { tab, filters, toggle, setSearch } = useDashboard();
  const { data: s } = useTabQuery<ReqSummary>("/requisitions/summary");
  if (!s) return <div className="card h-20 animate-pulse" />;
  // The card for where the page is: the stage filter on Requisitions, the card that led here elsewhere.
  const selected =
    tab === "requisitions"
      ? (filters.stage ?? [])
      : PIPE.filter((st) => GOES_TO[st]?.tab === tab && (GOES_TO[st]!.poStage ?? []).join() === (filters.poStage ?? []).join());
  return (
    <StageCards
      data={PIPE.map((st) => {
        const p = s.pipeline.find((x) => x.stage === st);
        return {
          key: st,
          label: stageLabel(st),
          value: p?.count ?? 0,
          color: stageVar(st),
          note: p?.medianAge != null ? `median ${p.medianAge} d` : undefined,
        };
      })}
      selected={selected}
      onSelect={(k) => {
        const go = GOES_TO[k];
        if (go) setSearch({ tab: go.tab, stage: undefined, poStage: go.poStage });
        else if (tab === "requisitions") toggle("stage", k);
        else setSearch({ tab: "requisitions", stage: [k as ReqStage], poStage: undefined });
      }}
      format={int}
    />
  );
}
